import React, { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ gfm: true, breaks: true });

const Markdown: React.FC<{ source: string; className?: string }> = ({ source, className }) => {
  const html = useMemo(() => {
    const raw = marked.parse(source || '') as string;
    return DOMPurify.sanitize(raw, { ADD_ATTR: ['target'] });
  }, [source]);
  return <div className={className || 'prose-dw'} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Markdown;
